import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isDeclaration } from "./parser/tokenizer";
import { ContextualKeyword } from "./parser/tokenizer/keywords";
import { TokenType as tt } from "./parser/tokenizer/types";
import { getNonTypeIdentifiers } from "./util/getNonTypeIdentifiers";
/**
 * Class responsible for preprocessing and bookkeeping import and export declarations within the
 * file.
 *
 * TypeScript uses a simpler mechanism that does not use functions like interopRequireDefault and
 * interopRequireWildcard, so we also allow that mode for compatibility.
 */

var CJSImportProcessor = /*#__PURE__*/function () {
  function CJSImportProcessor(nameManager, tokens, enableLegacyTypeScriptModuleInterop, options, isTypeScriptTransformEnabled, helperManager) {
    _classCallCheck(this, CJSImportProcessor);

    ;
    this.nameManager = nameManager;
    this.tokens = tokens;
    this.enableLegacyTypeScriptModuleInterop = enableLegacyTypeScriptModuleInterop;
    this.options = options;
    this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
    this.helperManager = helperManager;

    CJSImportProcessor.prototype.__init.call(this);

    CJSImportProcessor.prototype.__init2.call(this);

    CJSImportProcessor.prototype.__init3.call(this);

    CJSImportProcessor.prototype.__init4.call(this);

    CJSImportProcessor.prototype.__init5.call(this);
  }

  _createClass(CJSImportProcessor, [{
    key: "__init",
    value: function __init() {
      this.nonTypeIdentifiers = new Set();
    }
  }, {
    key: "__init2",
    value: function __init2() {
      this.importInfoByPath = new Map();
    }
  }, {
    key: "__init3",
    value: function __init3() {
      this.importsToReplace = new Map();
    }
  }, {
    key: "__init4",
    value: function __init4() {
      this.identifierReplacements = new Map();
    }
  }, {
    key: "__init5",
    value: function __init5() {
      this.exportBindingsByLocalName = new Map();
    }
  }, {
    key: "preprocessTokens",
    value: function preprocessTokens() {
      for (var i = 0; i < this.tokens.tokens.length; i++) {
        if (this.tokens.matches1AtIndex(i, tt._import) && !this.tokens.matches3AtIndex(i, tt._import, tt.name, tt.eq)) {
          this.preprocessImportAtIndex(i);
        }

        if (this.tokens.matches1AtIndex(i, tt._export) && !this.tokens.matches2AtIndex(i, tt._export, tt.eq)) {
          this.preprocessExportAtIndex(i);
        }
      }

      this.generateImportReplacements();
    }
    /**
     * In TypeScript, import statements that only import types should be removed. This does not count
     * bare imports.
     */

  }, {
    key: "pruneTypeOnlyImports",
    value: function pruneTypeOnlyImports() {
      var _this = this;

      this.nonTypeIdentifiers = getNonTypeIdentifiers(this.tokens, this.options);

      var _iterator = _createForOfIteratorHelper(this.importInfoByPath.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              path = _step$value[0],
              importInfo = _step$value[1];

          if (importInfo.hasBareImport || importInfo.hasStarExport || importInfo.exportStarNames.length > 0 || importInfo.namedExports.length > 0) {
            continue;
          }

          var names = [].concat(_toConsumableArray(importInfo.defaultNames), _toConsumableArray(importInfo.wildcardNames), _toConsumableArray(importInfo.namedImports.map(function (_ref) {
            var localName = _ref.localName;
            return localName;
          })));

          if (names.every(function (name) {
            return _this.isTypeName(name);
          })) {
            this.importsToReplace.set(path, "");
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "isTypeName",
    value: function isTypeName(name) {
      return this.isTypeScriptTransformEnabled && !this.nonTypeIdentifiers.has(name);
    }
  }, {
    key: "generateImportReplacements",
    value: function generateImportReplacements() {
      var _iterator2 = _createForOfIteratorHelper(this.importInfoByPath.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              path = _step2$value[0],
              importInfo = _step2$value[1];

          var defaultNames = importInfo.defaultNames,
              wildcardNames = importInfo.wildcardNames,
              namedImports = importInfo.namedImports,
              namedExports = importInfo.namedExports,
              exportStarNames = importInfo.exportStarNames,
              hasStarExport = importInfo.hasStarExport;

          if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0 && namedExports.length === 0 && exportStarNames.length === 0 && !hasStarExport) {
            // Import is never used, so don't even assign a name.
            this.importsToReplace.set(path, "require('".concat(path, "');"));
            continue;
          }

          var primaryImportName = this.getFreeIdentifierForPath(path);
          var secondaryImportName = void 0;

          if (this.enableLegacyTypeScriptModuleInterop) {
            secondaryImportName = primaryImportName;
          } else {
            secondaryImportName = wildcardNames.length > 0 ? wildcardNames[0] : this.getFreeIdentifierForPath(path);
          }

          var requireCode = "var ".concat(primaryImportName, " = require('").concat(path, "');");

          if (wildcardNames.length > 0) {
            var _iterator3 = _createForOfIteratorHelper(wildcardNames),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var wildcardName = _step3.value;
                var moduleExpr = this.enableLegacyTypeScriptModuleInterop ? primaryImportName : "".concat(this.helperManager.getHelperName("interopRequireWildcard"), "(").concat(primaryImportName, ")");
                requireCode += " var ".concat(wildcardName, " = ").concat(moduleExpr, ";");
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else if (exportStarNames.length > 0 && secondaryImportName !== primaryImportName) {
            requireCode += " var ".concat(secondaryImportName, " = ").concat(this.helperManager.getHelperName("interopRequireWildcard"), "(").concat(primaryImportName, ");");
          } else if (defaultNames.length > 0 && secondaryImportName !== primaryImportName) {
            requireCode += " var ".concat(secondaryImportName, " = ").concat(this.helperManager.getHelperName("interopRequireDefault"), "(").concat(primaryImportName, ");");
          }

          var _iterator4 = _createForOfIteratorHelper(namedExports),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _step4$value = _step4.value,
                  importedName = _step4$value.importedName,
                  localName = _step4$value.localName;
              requireCode += " ".concat(this.helperManager.getHelperName("createNamedExportFrom"), "(").concat(primaryImportName, ", '").concat(localName, "', '").concat(importedName, "');");
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          var _iterator5 = _createForOfIteratorHelper(exportStarNames),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var exportStarName = _step5.value;
              requireCode += " exports.".concat(exportStarName, " = ").concat(secondaryImportName, ";");
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          if (hasStarExport) {
            requireCode += " ".concat(this.helperManager.getHelperName("createStarExport"), "(").concat(primaryImportName, ");");
          }

          this.importsToReplace.set(path, requireCode);

          var _iterator6 = _createForOfIteratorHelper(defaultNames),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var defaultName = _step6.value;
              this.identifierReplacements.set(defaultName, "".concat(secondaryImportName, ".default"));
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          var _iterator7 = _createForOfIteratorHelper(namedImports),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _step7$value = _step7.value,
                  _importedName = _step7$value.importedName,
                  _localName = _step7$value.localName;
              this.identifierReplacements.set(_localName, "".concat(primaryImportName, ".").concat(_importedName));
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "getFreeIdentifierForPath",
    value: function getFreeIdentifierForPath(path) {
      var components = path.split("/");
      var lastComponent = components[components.length - 1];
      var baseName = lastComponent.replace(/\W/g, "");
      return this.nameManager.claimFreeName("_".concat(baseName));
    }
  }, {
    key: "preprocessImportAtIndex",
    value: function preprocessImportAtIndex(index) {
      var _importInfo$defaultNa, _importInfo$wildcardN, _importInfo$namedImpo;

      var defaultNames = [];
      var wildcardNames = [];
      var namedImports = [];
      index++;

      if ((this.tokens.matchesContextualAtIndex(index, ContextualKeyword._type) || this.tokens.matches1AtIndex(index, tt._typeof)) && !this.tokens.matches1AtIndex(index + 1, tt.comma) && !this.tokens.matchesContextualAtIndex(index + 1, ContextualKeyword._from)) {
        // import type declaration, so no need to process anything.
        return;
      }

      if (this.tokens.matches1AtIndex(index, tt.parenL)) {
        // Dynamic import, so nothing to do
        return;
      }

      if (this.tokens.matches1AtIndex(index, tt.name)) {
        defaultNames.push(this.tokens.identifierNameAtIndex(index));
        index++;

        if (this.tokens.matches1AtIndex(index, tt.comma)) {
          index++;
        }
      }

      if (this.tokens.matches1AtIndex(index, tt.star)) {
        // * as
        index += 2;
        wildcardNames.push(this.tokens.identifierNameAtIndex(index));
        index++;
      }

      if (this.tokens.matches1AtIndex(index, tt.braceL)) {
        var result = this.getNamedImports(index + 1);
        index = result.newIndex;

        var _iterator8 = _createForOfIteratorHelper(result.namedImports),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var namedImport = _step8.value;

            // Treat {default as X} as a default import to ensure usage of require interop helper
            if (namedImport.importedName === "default") {
              defaultNames.push(namedImport.localName);
            } else {
              namedImports.push(namedImport);
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }

      if (this.tokens.matchesContextualAtIndex(index, ContextualKeyword._from)) {
        index++;
      }

      if (!this.tokens.matches1AtIndex(index, tt.string)) {
        throw new Error("Expected string token at the end of import statement.");
      }

      var path = this.tokens.stringValueAtIndex(index);
      var importInfo = this.getImportInfo(path);

      (_importInfo$defaultNa = importInfo.defaultNames).push.apply(_importInfo$defaultNa, defaultNames);

      (_importInfo$wildcardN = importInfo.wildcardNames).push.apply(_importInfo$wildcardN, wildcardNames);

      (_importInfo$namedImpo = importInfo.namedImports).push.apply(_importInfo$namedImpo, namedImports);

      if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0) {
        importInfo.hasBareImport = true;
      }
    }
  }, {
    key: "preprocessExportAtIndex",
    value: function preprocessExportAtIndex(index) {
      if (this.tokens.matches2AtIndex(index, tt._export, tt._var) || this.tokens.matches2AtIndex(index, tt._export, tt._let) || this.tokens.matches2AtIndex(index, tt._export, tt._const)) {
        this.preprocessVarExportAtIndex(index);
      } else if (this.tokens.matches2AtIndex(index, tt._export, tt._function) || this.tokens.matches2AtIndex(index, tt._export, tt._class)) {
        var exportName = this.tokens.identifierNameAtIndex(index + 2);
        this.addExportBinding(exportName, exportName);
      } else if (this.tokens.matches3AtIndex(index, tt._export, tt.name, tt._function)) {
        var _exportName = this.tokens.identifierNameAtIndex(index + 3);

        this.addExportBinding(_exportName, _exportName);
      } else if (this.tokens.matches2AtIndex(index, tt._export, tt.braceL)) {
        this.preprocessNamedExportAtIndex(index);
      } else if (this.tokens.matches2AtIndex(index, tt._export, tt.star)) {
        this.preprocessExportStarAtIndex(index);
      }
    }
  }, {
    key: "preprocessVarExportAtIndex",
    value: function preprocessVarExportAtIndex(index) {
      var depth = 0; // Handle cases like `export let {x} = y;`, starting at the open-brace in that case.

      for (var i = index + 2;; i++) {
        if (this.tokens.matches1AtIndex(i, tt.braceL) || this.tokens.matches1AtIndex(i, tt.dollarBraceL) || this.tokens.matches1AtIndex(i, tt.bracketL)) {
          depth++;
        } else if (this.tokens.matches1AtIndex(i, tt.braceR) || this.tokens.matches1AtIndex(i, tt.bracketR)) {
          depth--;
        } else if (depth === 0 && !this.tokens.matches1AtIndex(i, tt.name)) {
          break;
        } else if (this.tokens.matches1AtIndex(1, tt.eq)) {
          var endIndex = this.tokens.currentToken().rhsEndIndex;

          if (endIndex == null) {
            throw new Error("Expected = token with an end index.");
          }

          i = endIndex - 1;
        } else {
          var token = this.tokens.tokens[i];

          if (isDeclaration(token)) {
            var exportName = this.tokens.identifierNameAtIndex(i);
            this.identifierReplacements.set(exportName, "exports.".concat(exportName));
          }
        }
      }
    }
    /**
     * Walk this export statement just in case it's an export...from statement.
     * If it is, combine it into the import info for that path. Otherwise, just
     * bail out; it'll be handled later.
     */

  }, {
    key: "preprocessNamedExportAtIndex",
    value: function preprocessNamedExportAtIndex(index) {
      var _importInfo$namedExpo;

      // export {
      index += 2;

      var _this$getNamedImports = this.getNamedImports(index),
          newIndex = _this$getNamedImports.newIndex,
          namedImports = _this$getNamedImports.namedImports;

      index = newIndex;

      if (this.tokens.matchesContextualAtIndex(index, ContextualKeyword._from)) {
        index++;
      } else {
        // Reinterpret "a as b" to be local/exported rather than imported/local.
        var _iterator9 = _createForOfIteratorHelper(namedImports),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _step9$value = _step9.value,
                localName = _step9$value.importedName,
                exportedName = _step9$value.localName;
            this.addExportBinding(localName, exportedName);
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        return;
      }

      if (!this.tokens.matches1AtIndex(index, tt.string)) {
        throw new Error("Expected string token at the end of import statement.");
      }

      var path = this.tokens.stringValueAtIndex(index);
      var importInfo = this.getImportInfo(path);

      (_importInfo$namedExpo = importInfo.namedExports).push.apply(_importInfo$namedExpo, _toConsumableArray(namedImports));
    }
  }, {
    key: "preprocessExportStarAtIndex",
    value: function preprocessExportStarAtIndex(index) {
      var exportedName = null;

      if (this.tokens.matches3AtIndex(index, tt._export, tt.star, tt._as)) {
        // export * as
        index += 3;
        exportedName = this.tokens.identifierNameAtIndex(index); // foo from

        index += 2;
      } else {
        // export * from
        index += 3;
      }

      if (!this.tokens.matches1AtIndex(index, tt.string)) {
        throw new Error("Expected string token at the end of star export statement.");
      }

      var path = this.tokens.stringValueAtIndex(index);
      var importInfo = this.getImportInfo(path);

      if (exportedName !== null) {
        importInfo.exportStarNames.push(exportedName);
      } else {
        importInfo.hasStarExport = true;
      }
    }
  }, {
    key: "getNamedImports",
    value: function getNamedImports(index) {
      var namedImports = [];

      while (true) {
        if (this.tokens.matches1AtIndex(index, tt.braceR)) {
          index++;
          break;
        } // Flow type imports should just be ignored.


        var isTypeImport = false;

        if ((this.tokens.matchesContextualAtIndex(index, ContextualKeyword._type) || this.tokens.matches1AtIndex(index, tt._typeof)) && this.tokens.matches1AtIndex(index + 1, tt.name) && !this.tokens.matchesContextualAtIndex(index + 1, ContextualKeyword._as)) {
          isTypeImport = true;
          index++;
        }

        var importedName = this.tokens.identifierNameAtIndex(index);
        var localName = void 0;
        index++;

        if (this.tokens.matchesContextualAtIndex(index, ContextualKeyword._as)) {
          index++;
          localName = this.tokens.identifierNameAtIndex(index);
          index++;
        } else {
          localName = importedName;
        }

        if (!isTypeImport) {
          namedImports.push({
            importedName: importedName,
            localName: localName
          });
        }

        if (this.tokens.matches2AtIndex(index, tt.comma, tt.braceR)) {
          index += 2;
          break;
        } else if (this.tokens.matches1AtIndex(index, tt.braceR)) {
          index++;
          break;
        } else if (this.tokens.matches1AtIndex(index, tt.comma)) {
          index++;
        } else {
          throw new Error("Unexpected token: ".concat(JSON.stringify(this.tokens.tokens[index])));
        }
      }

      return {
        newIndex: index,
        namedImports: namedImports
      };
    }
    /**
     * Get a mutable import info object for this path, creating one if it doesn't
     * exist yet.
     */

  }, {
    key: "getImportInfo",
    value: function getImportInfo(path) {
      var existingInfo = this.importInfoByPath.get(path);

      if (existingInfo) {
        return existingInfo;
      }

      var newInfo = {
        defaultNames: [],
        wildcardNames: [],
        namedImports: [],
        namedExports: [],
        hasBareImport: false,
        exportStarNames: [],
        hasStarExport: false
      };
      this.importInfoByPath.set(path, newInfo);
      return newInfo;
    }
  }, {
    key: "addExportBinding",
    value: function addExportBinding(localName, exportedName) {
      if (!this.exportBindingsByLocalName.has(localName)) {
        this.exportBindingsByLocalName.set(localName, []);
      }

      this.exportBindingsByLocalName.get(localName).push(exportedName);
    }
    /**
     * Return the code to use for the import for this path, or the empty string if
     * the code has already been "claimed" by a previous import.
     */

  }, {
    key: "claimImportCode",
    value: function claimImportCode(importPath) {
      var result = this.importsToReplace.get(importPath);
      this.importsToReplace.set(importPath, "");
      return result || "";
    }
  }, {
    key: "getIdentifierReplacement",
    value: function getIdentifierReplacement(identifierName) {
      return this.identifierReplacements.get(identifierName) || null;
    }
    /**
     * Return a string like `exports.foo = exports.bar`.
     */

  }, {
    key: "resolveExportBinding",
    value: function resolveExportBinding(assignedName) {
      var exportedNames = this.exportBindingsByLocalName.get(assignedName);

      if (!exportedNames || exportedNames.length === 0) {
        return null;
      }

      return exportedNames.map(function (exportedName) {
        return "exports.".concat(exportedName);
      }).join(" = ");
    }
    /**
     * Return all imported/exported names where we might be interested in whether usages of those
     * names are shadowed.
     */

  }, {
    key: "getGlobalNames",
    value: function getGlobalNames() {
      return new Set([].concat(_toConsumableArray(this.identifierReplacements.keys()), _toConsumableArray(this.exportBindingsByLocalName.keys())));
    }
  }]);

  return CJSImportProcessor;
}();

export { CJSImportProcessor as default };